export { default, meta } from "/Users/markmulvaney/Local-Sites/padel-africa/padel-web/app/routes/partners/index.tsx";